module.exports = __webpack_public_path__ + "static/media/12-8.00d06795.mp3";